// courseService

import api from '../api/api';
import { Course } from '../types';

export const getCourses = async (schoolId?: number, classLevel?: string): Promise<Course[]> => {
  const params: any = {};
  if (schoolId) params.school_id = schoolId;
  if (classLevel) params.class_level = classLevel;
  const response = await api.get('/courses/', { params });
  return response.data as Course[];
};
